import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setRewardsFetched } from 'store/Dashboard/actions'
import { setRewards } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'

export function useRewards() {
  const dispatch = useDispatch()

  const {
    rewardsFetched,
    rewardsData: { roleArray, rewardsType },
  } = useSelector((state) => state.dashboard)

  const fetchRewards = (role = '') => {
    dispatch(setRewards({ loading: true }))
    dispatch(setRewards({ usersLoading: true }))
    dispatch(setRewards({ selectedRewardRole: role || 'All' }))

    const url = role ? `/stores/rewards?role=${role}` : `/stores/rewards`

    if (rewardsType === 'users') {
      AxiosInstance.get('/users/leaderboard').then((data) => {
        dispatch(setRewards({ usersLoading: false }))
        dispatch(setRewards({ userRewards: data.leaderboard }))
      })
    }

    if (rewardsType === 'location') {
      AxiosInstance.get(url).then(({ stores }) => {
        dispatch(setRewards({ loading: false }))
        dispatch(setRewards({ storesWithRewards: stores }))
        if (!roleArray.length) {
          removeDuplicatesRoles(stores)
        }
      })
    }
    dispatch(setRewardsFetched(true))
  }

  const removeDuplicatesRoles = (stores) => {
    const allRoles = stores
      .map(({ user_roles }) => JSON.parse(user_roles))
      .flat()

    const uniqueRoles = Array.from(new Set(allRoles)).filter(Boolean)
    dispatch(setRewards({ roleArray: uniqueRoles }))
  }

  useEffect(() => {
    if (rewardsFetched) return
    fetchRewards()
  }, [rewardsFetched])

  return { fetchRewards }
}
